module.exports = __webpack_public_path__ + "static/media/candy-corn.58a42a3d.svg";